module.exports = __webpack_public_path__ + "img/background-menu.b0dc2fe6.svg";